import React from 'react';
import { Link } from 'react-router-dom';
import '../CSS/NotFound.css';

const NotFound = () => (
  <main className="not-found">
    <div className="not-found__inner">
      <span className="not-found__code">404</span>
      <h1 className="not-found__title">Page not found</h1>
      <p className="not-found__desc">The page you're looking for doesn't exist or has been moved.</p>
      <Link to="/" className="btn btn--primary">← Back to Home</Link>
    </div>
  </main>
);

export default NotFound;
